export default __webpack_public_path__ + "static/media/payment_secure_image.7e5c2172.svg";